'use client'

import { useRef, useState } from 'react'
import { motion } from 'framer-motion'
import { Join } from 'design-studio/lib'

interface TerminalBoxProps {
  children: React.ReactNode
  className?: string
  copyContent?: string
  copyButton?: boolean
}

export function TerminalBox({
  children,
  className = '',
  copyContent,
  copyButton = true,
}: TerminalBoxProps) {
  const [copied, setCopied] = useState(false)
  const contentRef = useRef<HTMLSpanElement>(null)

  const handleCopy = async () => {
    const text = copyContent ?? contentRef.current?.innerText
    if (text) {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 1600)
    }
  }

  return (
    <div
      className={Join(
        className,
        'overflow-hidden rounded-lg border border-slate-300 bg-slate-100 dark:border-slate-700 dark:bg-[#112233]',
      )}
    >
      {/* Terminal Header */}
      {/* <div className="flex items-center h-4 border-b border-slate-300 bg-slate-200 dark:border-slate-700 dark:bg-slate-800" /> */}

      {/* Terminal Content */}
      <div className="p-2 font-mono text-sm">
        <div className="flex items-center">
          <span
            ref={contentRef}
            className="ml-2 text-slate-900 dark:text-slate-100"
          >
            {children}
          </span>
          {copyButton && (
            <button
              onClick={handleCopy}
              className="ml-auto cursor-pointer rounded-md p-2 text-slate-500 transition-all hover:bg-slate-200 hover:text-slate-700 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200"
              title={copied ? 'Copied!' : 'Copy to clipboard'}
              aria-label="Copy code"
            >
              {copied ? (
                <motion.svg
                  key="check"
                  className="h-5 w-5 text-green-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{
                    type: 'spring',
                    stiffness: 700,
                    damping: 20,
                  }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </motion.svg>
              ) : (
                <svg
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
